import styles from "./PageHeader.module.css";

// The page title's class, for a page that renders its own h1 (PageHeader's `heading`).
export const pageTitleClassName = styles.title;
